import { makeApiSuccess } from 'scenes/common/helpers/apiData';
import { ApiData } from 'scenes/common/types';

import { HomeQuoteDetails } from 'scenes/home/types';
import { unmarshalPremiums } from 'scenes/home/api/quote/marshaller/premium';
import { unmarshalCampaigns } from 'scenes/common/api/quote/marshaller/campaign';

import {
  unmarshalBuildingExcesses,
  unmarshalContentsExcesses,
  unmarshalPortablesExcess,
  unmarshalSelectedBuildingExcess,
  unmarshalSelectedContentsExcess,
} from './excess';
import { WireHomeQuoteResponse } from '../types';
import { unmarshalGeneralPortables } from './limit';

export const unmarshalQuoteResponse = (
  response: WireHomeQuoteResponse
): ApiData<HomeQuoteDetails> =>
  makeApiSuccess<HomeQuoteDetails>({
    payload: response.payload,
    insuranceOptions: unmarshalPremiums(response.payload),
    buildingExcesses: unmarshalBuildingExcesses(response.payload),
    contentsExcesses: unmarshalContentsExcesses(response.payload),
    portablesExcesses: unmarshalPortablesExcess(response.payload),
    unspecifiedPortableLimitRanges: unmarshalGeneralPortables(response.payload),

    userSelections: {
      buildingExcess: unmarshalSelectedBuildingExcess(response.payload),
      contentsExcess: unmarshalSelectedContentsExcess(response.payload),
    },

    campaigns: unmarshalCampaigns(response.payload),
  });
